import { Component, OnInit } from '@angular/core';
import { AdmEquipeService } from 'src/app/shared/api/adm-equipe.service';
import { ClientesService } from 'src/app/shared/api/clientes.service';
import { ConfigurationColumn } from 'src/app/shared/model/resource';
import { equipeResource } from '../../equipes/equipe.resource';
import { clienteResource } from '../cliente.resource';
// import { equipeClienteResource } from '../equipe-cliente.resource';

@Component({
    selector: 'app-cliente-form',
    templateUrl: './cliente-form.component.html',
    styleUrls: ['./cliente-form.component.css']
})
export class ClienteFormComponent implements OnInit {
    clienteColumns: ConfigurationColumn[] = clienteResource.colunas;
    clienteResource = clienteResource;
    equipeResource = equipeResource;
    entidadeOriginal: any;

    constructor(
        public clienteService: ClientesService,
        public adminEquipeService: AdmEquipeService
    ) {}

    ngOnInit(): void {}

    setarIdEquipe(entidade: any) {
        this.adminEquipeService.setBaseUrl(entidade[clienteResource.fieldPk] as string);
    }
}
